import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from '../../themeContext'; // Import the useTheme hook
import { FiSunrise, FiSunset } from "react-icons/fi";


const Themetoggle = () => {
  const { theme, setTheme } = useTheme(); // Use the context
  const themeToggle = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };
  // Choose icon based on the current theme
  const Icon = theme === 'dark' ? FiSunrise : FiSunset;

  return (
    <button className="nav_ac" onClick={themeToggle} style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
      <Icon /> {/* You can adjust the size as needed */}
    </button>
  );
};

export default Themetoggle;
